<template>
<div>
    <base-header v-once pageName="영업활동계획서" :popup="true"></base-header>

    <section id="wrap">
        <h2 class="bsnsAcpln-mem"><em v-bind:class="pstnChk()"></em><span>{{userName}}</span><i>{{userId}}</i></h2>
        <h3 class="bsnsAcpln-tit">{{planYr}}년 {{planMn}}월 영업활동계획</h3>
        <div class="bsnsAcpln-view">
            <div>
                <h6>실적 목표</h6>
                <span><em>{{amtSum | numFormat}}</em>만원</span>
                <ul>
                    <li v-for="amt in amtList" v-bind:key="amt.cateCd">
                        <strong>{{amt.cateNm}}</strong>
                        <span><em>{{amt.goalAmt | numFormat}}</em>만원</span>
                    </li>
                </ul>
            </div>
            <div>
                <h6>활동 목표</h6>
                <ul class="flex">
                    <li v-for="act in activityItems" v-bind:key="act.cateCd">
                        <strong>{{act.cateNm}}</strong>
                        <span><em>{{act.goalCscnt | numFormat}}</em>건</span>
                    </li>
                </ul>
            </div>
            <div v-if="counselItems.length">
                <h6>상담 목표</h6>
                <ul class="flex">
                    <li v-for="act in counselItems" v-bind:key="act.cateCd">
                        <strong>{{act.cateNm}}</strong>
                        <span><em>{{act.goalCscnt | numFormat}}</em>건</span>
                    </li>
                </ul>
            </div>
        </div>
        <dl class="bsnsAcpln-view" v-if="periodRows.length">
            <dt>구간 마감</dt>
            <dd>
                <p>단위(만원)</p>
                <table>
                    <thead>
                        <tr>
                            <th>마감</th>
                            <th>목표</th>
                            <th v-for="amt in amtList" v-bind:key="'th-'+amt.cateCd">{{amt.cateNm}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="row in periodRows" v-bind:key="row.label">
                            <td>{{row.label}}</td>
                            <td>{{Math.floor(row.ratio*100)+'%'}}</td>
                            <td v-for="amt in amtList" v-bind:key="row.label+'-'+amt.cateCd">{{Math.floor(Number(amt.goalAmt||0)*row.ratio) | numFormat}}</td>
                        </tr>
                    </tbody>
                </table>
            </dd>
        </dl>
        <dl class="bsnsAcpln-view">
            <dt>기타</dt>
            <dd class="memo">{{memo}}</dd>
        </dl>
    </section>
    <div class="btnWrap">
        <button type="button" class="white" @click="close()">닫기</button>
    </div>
</div>
</template>

<script>
// 영업활동계획(신규) - 지국장이 조직원 계획 상세를 보는 화면 (읽기 전용).
// 새로 만든 /api/v1/bsnplan2/form 을 그대로 재사용한다 — sqno 로 카테고리+기존값+작성자정보를 함께 준다.
// 기존 /mypage/bsnPlnMemberDetail (BsnPlnMemberDetail.vue) 는 전혀 건드리지 않는다.

// 활동목표(BPG) 중 "상담 목표" 섹션에 들어갈 카테고리 코드 — 기존상담(BPG04), 신규상담(BPG05).
var COUNSEL_CATE_CDS = ['BPG04', 'BPG05'];

export default {
  name: "BsnPlan2MemberDetail",

  data() {
    return {
      sqno: this.$route.query.sqno,
      userName: '',
      userId: '',
      pstn: '',
      planYr: '',
      planMn: '',
      memo: '',
      amtList: [],
      actList: [],
      periodRows: []
    };
  },

  computed: {
    amtSum: function() {
      return this.amtList.reduce(function(sum, amt) {
        return sum + Number(amt.goalAmt || 0);
      }, 0);
    },
    counselItems: function() {
      return this.actList.filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) !== -1; });
    },
    activityItems: function() {
      return this.actList.filter(function(act) { return COUNSEL_CATE_CDS.indexOf(act.cateCd) === -1; });
    }
  },

  methods: {
    close: function() {
      this.$utils.nativeIf.outbound.close();
    },
    pstnChk: function() {
      if (this.pstn == 'COG02') return 'epLv1';
      if (this.pstn == 'COGA2') return 'epLvA1';
      if (this.pstn == 'COG03') return 'epLv2';
      if (this.pstn == 'COG04') return 'epLv3';
      if (this.pstn == 'COG05') return 'epLv4';
      return '';
    }
  },

  filters: {
    numFormat: function(num) {
      if (num == null || num == 0) return 0;
      var n = num + '';
      var reg = /(^[+-]?\d+)(\d{3})/;
      while (reg.test(n)) n = n.replace(reg, '$1' + ',' + '$2');
      return n;
    }
  },

  created: function() {
    if (!this.sqno) return;

    var that = this;
    var parameters = { sqno: this.sqno };
    this.$api.bsnPlan2
      .form(parameters)
      .then(function(data) {
        if (data) {
          that.userName = data.userName;
          that.userId = data.userId;
          that.pstn = data.pstn;
          that.planYr = data.planYr;
          that.planMn = data.planMn;
          that.memo = data.memo;
          that.amtList = data.amtList || [];
          that.actList = data.actList || [];
        }
      })
      .catch(function(error) {
        alert(error.rtMsg);
      });

    // 구간 마감 자동비율표 — 기존 화면과 동일하게 TBL_COMN_CD(PREN_CD='CSC') 기반 비율을 재사용
    this.$api.mypage
      .bsnPlnInfo({})
      .then(function(data) {
        if (data && data.period && data.period.length >= 5) {
          var labels = ['1영업일', '1구간', '2구간', '3구간', '월마감'];
          that.periodRows = data.period.slice(0, 5).map(function(p, i) {
            return { label: labels[i], ratio: Number(p.cdVl1) };
          });
        }
      })
      .catch(function(error) {
        console.log(error);
      });
  }
};
</script>
